var exports = {
  "k": "x8b4e8595--482267--container",
};

module.exports = exports;
